/**
=========================================================
* Soft UI Dashboard React - v4.0.1
=========================================================
*/

import Dashboard from "layouts/dashboard";
import Profile from "layouts/profile";
import EmailSettings from "layouts/emailSettings";
import StatusSettings from "layouts/statusSettings";
import StatusMappings from "layouts/statusMappings";
import SettingsSection from "layouts/settings";
import TaskJobs from "layouts/taskJobs";
import VendorFees from "layouts/vendorFees";
import AutomationRules from "layouts/automationRules";
import VendorApiKeys from "layouts/vendorApiKeys";
import ApiDocs from "layouts/apiDocs";

import Shop from "examples/Icons/Shop";
import Office from "examples/Icons/Office";
import Settings from "examples/Icons/Settings";
import SpaceShip from "examples/Icons/SpaceShip";
import { FaEnvelope, FaRobot, FaTasks, FaExchangeAlt, FaMagic, FaFileInvoiceDollar, FaKey, FaBook } from "react-icons/fa";
import { MdLogout } from "react-icons/md";

import ProtectedRoute from "proctectedRoute/ProtectedRoute";
import LogOut from "layouts/authentication/Logout/LogOut";
import ProjectTableV2 from "layouts/dashboard/components/ProjectTableV2";
import UserMangemntTable from "layouts/dashboard/components/UserMgtData";
import VendorMangemntTable from "layouts/dashboard/components/VendorMgtData";
import DashboardSearchAddress from "components/DashboardSearchAddress";
import APIIntents from "layouts/apiIntents";

import {
  AccountCircleRounded,
  GroupsRounded,
  SettingsRounded,
  HandshakeRounded,
} from "@mui/icons-material";

const userRole = localStorage.getItem("role");

const routes = [
  // ✅ TOP MENU
  {
    type: "collapse",
    name: "Dashbord",
    key: "dashboard",
    route: "/dashboard",
    icon: <SpaceShip size="12px" />,
    component: (
      <ProtectedRoute
        allowedRoles={["admin", "customer", "vendor"]}
        element={<Dashboard />}
      />
    ),
    noCollapse: true,
  },

  {
    type: "collapse",
    name: "Ny bestilling",
    key: "add-address",
    route: "/add-address",
    icon: <Shop size="12px" />,
    component: (
      <ProtectedRoute
        allowedRoles={["admin", "customer", "vendor"]}
        element={<DashboardSearchAddress />}
      />
    ),
    noCollapse: true,
  },

  // ✅ main menu (NOT submenu)
  // Den klassiske bestillingslisten er fjernet; den nye prosjektvisningen
  // (tidligere /bestillinger-ny) eier nå /bestillinger.
  {
    type: "collapse",
    name: "Alle bestillinger",
    key: "bestillinger",
    route: "/bestillinger",
    icon: <Office size="12px" />,
    component: (
      <ProtectedRoute
        allowedRoles={["admin", "customer", "vendor"]}
        element={<ProjectTableV2 />}
      />
    ),
    noCollapse: true,
  },


  // ✅ ADMIN SECTION (title + divider + admin menus) -> ONLY ADMIN
  ...(userRole === "admin"
    ? [
        { type: "divider", key: "divider-before-admin" },
        { type: "title", title: "Adminsider", key: "admin-pages" },

        {
          type: "collapse",
          name: "Innstillinger",
          key: "settings-menu",
          route: "/settings",
          icon: <SettingsRounded size="12px" />,
          component: <ProtectedRoute element={<SettingsSection />} allowedRoles={["admin"]} />,
          collapse: [
            {
              type: "collapse",
              name: "BMAx",
              key: "bmax-settings",
              route: "/settings",
              icon: <SettingsRounded size="12px" />,
              component: <ProtectedRoute element={<SettingsSection />} allowedRoles={["admin"]} />,
              noCollapse: true,
            },
            {
              type: "collapse",
              name: "E-post",
              key: "email-settings",
              route: "/email-settings",
              icon: <FaEnvelope size="12px" />,
              component: <ProtectedRoute element={<EmailSettings />} allowedRoles={["admin"]} />,
              noCollapse: true,
            },
            {
              type: "collapse",
              name: "Status",
              key: "status-settings",
              route: "/status-settings",
              icon: <Settings size="12px" />,
              component: <ProtectedRoute element={<StatusSettings />} allowedRoles={["admin"]} />,
              noCollapse: true,
            },
            {
              type: "collapse",
              name: "Status-mapping",
              key: "status-mappings",
              route: "/status-mappings",
              icon: <FaExchangeAlt size="12px" />,
              component: <ProtectedRoute element={<StatusMappings />} allowedRoles={["admin"]} />,
              noCollapse: true,
            },
            {
              type: "collapse",
              name: "Automatiseringer",
              key: "automation-rules",
              route: "/automation-rules",
              icon: <FaMagic size="12px" />,
              component: <ProtectedRoute element={<AutomationRules />} allowedRoles={["admin"]} />,
              noCollapse: true,
            },
            {
              type: "collapse",
              name: "API-nøkler",
              key: "api-nokler",
              route: "/api-nokler",
              icon: <FaKey size="12px" />,
              component: <ProtectedRoute element={<VendorApiKeys />} allowedRoles={["admin"]} />,
              noCollapse: true,
            },
          ],
          noCollapse: false,
        },

        {
          type: "collapse",
          name: "Brukeradministrasjon",
          key: "users-management",
          route: "/users-management",
          icon: <GroupsRounded size="12px" />,
          component: <ProtectedRoute element={<UserMangemntTable />} allowedRoles={["admin"]} />,
          noCollapse: true,
        },

        {
          type: "collapse",
          name: "Leverandør",
          key: "vendors-management",
          route: "/vendors-management",
          icon: <HandshakeRounded size="12px" />,
          component: <ProtectedRoute element={<VendorMangemntTable />} allowedRoles={["admin"]} />,
          noCollapse: true,
        },
        {
          type: "collapse",
          name: "Formidlingsgebyr",
          key: "vendor-fees",
          route: "/formidlingsgebyr",
          icon: <FaFileInvoiceDollar size="14px" />,
          component: <ProtectedRoute element={<VendorFees />} allowedRoles={["admin"]} />,
          noCollapse: true,
        },
        {
          type: "collapse",
          name: "Jobber",
          key: "task-jobs",
          route: "/task-jobs",
          icon: <FaTasks size="14px" />,
          component: <ProtectedRoute element={<TaskJobs />} allowedRoles={["admin"]} />,
          noCollapse: true,
        },
        {
          type: "collapse",
          name: "Betong.ai",
          key: "betong.ai",
          route: "/ai-intents",
          icon: <FaRobot size="16px" />,
          component: <ProtectedRoute element={<APIIntents />} allowedRoles={["admin"]} />,
          noCollapse: true,
        },
      ]
    : []),

  // API-dokumentasjon for leverandørintegrasjoner. Selve siden er OFFENTLIG
  // (egen rute i App.js — den beskriver bare det åpne API-et og inneholder
  // ingen hemmeligheter); menyoppføringen vises likevel bare for admin og
  // leverandør, siden kunder ikke har noe der å gjøre.
  ...(userRole === "admin" || userRole === "vendor"
    ? [
        {
          type: "collapse",
          name: "API-dokumentasjon",
          key: "api-dokumentasjon",
          route: "/api-dokumentasjon",
          icon: <FaBook size="12px" />,
          component: <ApiDocs />,
          noCollapse: true,
        },
      ]
    : []),

  { type: "divider", key: "divider-before-profile" },

  // ✅ always visible
  { type: "title", title: "Min konto", key: "my-account-title" },

  // ✅ PROFILE + LOGOUT submenu
  {
    type: "collapse",
    name: "Profil",
    key: "profile-menu",
    route: "/profile",
    icon: <AccountCircleRounded size="12px" />,
    component: (
      <ProtectedRoute element={<Profile />} allowedRoles={["admin", "vendor", "customer"]} />
    ),
    collapse: [
      {
        type: "collapse",
        name: "Logg ut",
        key: "log-out",
        route: "/logout",
        icon: <MdLogout size="12px" />,
        component: <LogOut />,
        noCollapse: true,
      },
    ],
    noCollapse: false,
  },

  // ✅ hidden route so /profile works
  {
    type: "route",
    name: "Profil Route",
    key: "profile-hidden-route",
    route: "/profile",
    component: (
      <ProtectedRoute element={<Profile />} allowedRoles={["admin", "vendor", "customer"]} />
    ),
  },
];

export default routes;
